import { SimpleMapper } from '@nextgenleads/mapper';

export const mapper = new SimpleMapper();
